import React from 'react';
import { BodySmall, DetailCapsSmall } from 'src/shared/design-system/Text';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

const TrialShefWarningContainer = styled.div`
  background: #f7f7f7;
  margin: 10px 10px 30px 10px;
  padding: 20px;
  ${DetailCapsSmall} {
    color: ${Colors.GRAY_DARK_10};
    margin-bottom: 10px;
  }
  ${BodySmall} {
    color: #383838;
  }
`;

export const TrialShefWarning: React.FC = () => (
  <TrialShefWarningContainer>
    <DetailCapsSmall>A note about Trial Shefs</DetailCapsSmall>
    <BodySmall>
      We are constantly monitoring the tasting results for trial shefs. If we determine the shef you are ordering from
      does not meet our high standards before your food arrives, we will cancel your order and reward you with a $15
      credit.
    </BodySmall>
  </TrialShefWarningContainer>
);
